function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#luxury_svg__clip0_1_58)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.188.7h-.093l-.041.083L1.05 4.789l-.109.217h4.234l.04-.089L7.019.911 7.114.7H3.188zm5.53 0h-.23l.092.21 1.768 4.006.04.09h4.232l-.11-.217L12.509.783 12.467.7h-3.75zm-.78.09L7.804.48l-.139.309-1.79 4.005-.095.211h4.008l-.093-.21L7.94.79zm-6.59 4.765h-.3l.18.24 5.51 7.348.266-.126-1.837-7.348-.029-.114H1.347zm4.55 0h-.193l.047.186 1.883 7.535h.291L9.81 5.74l.046-.186H5.897zm4.642 0h-.117l-.028.114-1.837 7.348.265.127 5.512-7.35.18-.24H10.54zM.176 5.31L2.756.15h10.05l2.58 5.16-7.605 10.14L.277 5.445h0L.176 5.31z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "luxury_svg__clip0_1_58"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));
function SvgLuxury(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgLuxury;